// UI 개인 설정(UiPrefs: 터치 버튼 크기·렌더 품질·렌더러). 게임 상태가 아니므로 UI가 localStorage에 직접 저장한다.
import type { UiPrefs } from '../shared/types';
import { sanitizeTouchPos } from './skillHudLayout';

export type { UiPrefs };

const KEY = 'dungeonhero.ui.v1';
const QUALITIES = ['auto', 'low', 'mid', 'high'] as const;

export function loadPrefs(): UiPrefs {
  const p: UiPrefs = { touchScale: 1, quality: 'auto', renderer: 'auto', autoPotion: 0, touchOpacity: 1, touchPos: {} };
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(KEY) : null;
    if (raw) {
      const j = JSON.parse(raw) as Partial<UiPrefs>;
      if (typeof j.touchScale === 'number' && Number.isFinite(j.touchScale)) p.touchScale = Math.min(1.5, Math.max(0.7, j.touchScale));
      if (typeof j.quality === 'string' && (QUALITIES as readonly string[]).includes(j.quality)) p.quality = j.quality;
      if (j.renderer === 'webgl' || j.renderer === 'auto') p.renderer = j.renderer;
      // 자동 물약 문턱(D2c): 정해진 선택지만(0·30%·50%)
      if (j.autoPotion === 0.3 || j.autoPotion === 0.5) p.autoPotion = j.autoPotion;
      // 터치 버튼 투명도·고객 배치(UX-FLOW 3절)
      if (typeof j.touchOpacity === 'number' && Number.isFinite(j.touchOpacity)) p.touchOpacity = Math.min(1, Math.max(0.35, j.touchOpacity));
      p.touchPos = sanitizeTouchPos(j.touchPos);
    }
  } catch {
    /* 저장소 접근 불가: 기본값 사용 */
  }
  return p;
}

export function savePrefs(p: UiPrefs): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* 무시 */
  }
}
